module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(!_vm.detailed) ? _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.item.url
    }
  }, [_vm._v("Mere info")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.item.description) ? _c('p', {
    directives: [{
      name: "nl2br",
      rawName: "v-nl2br",
      value: (_vm.item.description),
      expression: "item.description"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.item.externalUrl) ? _c('a', {
    attrs: {
      "href": _vm.item.externalUrl
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.externalUrl)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [(_vm.item.type || _vm.item.audiences) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.type && _vm.item.type.name) ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "offer-type"
    }
  }), _vm._v(" "), _vm._l((_vm.item.types), function(type, index) {
    return [_vm._v("\r\n\t\t\t\t\t" + _vm._s(type.name)), (index + 1 < _vm.item.types.length) ? [_vm._v(", ")] : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('sky-svg', {
    attrs: {
      "name": "offer-audiences"
    }
  }), _vm._v(" "), _vm._l((_vm.item.audiences), function(audience) {
    return (_vm.item.audiences.length) ? _c('span', [_vm._v(_vm._s(audience.name)), _c('em', [_vm._v(",")])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), ((_vm.item.organization) && _vm.item.organization.phone || _vm.item.organization.email) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.organization.phone) ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v(" " + _vm._s(_vm.item.organization.phone) + "\r\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.item.organization.email) ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "mail"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.item.organization.email
    }
  }, [_vm._v(_vm._s(_vm.item.organization.email))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.location.parent || _vm.item.organization.name || _vm.item.organization.address || _vm.item.organization.zipcode || _vm.item.organization.city) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.location.parent) ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.item.location.parent) + "\r\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.item.organization.name || _vm.item.organization.address || _vm.item.organization.zipcode || _vm.item.organization.city) ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "offer-address"
    }
  }), _vm._v("\r\n\t\t\t\t" + _vm._s(_vm.item.organization.name)), _c('br'), _vm._v("\r\n\t\t\t\t" + _vm._s(_vm.item.organization.address)), (_vm.item.organization.address) ? [_vm._v(",")] : _vm._e(), _vm._v(" " + _vm._s(_vm.item.organization.zipcode) + " " + _vm._s(_vm.item.organization.city) + "\r\n\t\t\t")], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.detailed) ? [(_vm.item.contactPersons && _vm.item.contactPersons.length) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.item.contactPersons && _vm.item.contactPersons.length) ? _c('div', {
    staticClass: "contact-persons"
  }, [_c('h2', [_vm._v("Kontaktpersoner")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.item.contactPersons), function(person) {
    return _c('div', {
      staticClass: "column"
    }, [_c('address', [_c('h4', [_vm._v(_vm._s(person.name))]), _vm._v(" "), (person.phone) ? _c('div', [_c('sky-svg', {
      attrs: {
        "name": "phone"
      }
    }), _vm._v(" " + _vm._s(person.phone) + "\r\n\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (person.email) ? _c('div', [_c('sky-svg', {
      attrs: {
        "name": "mail"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'mailto:' + person.email
      }
    }, [_vm._v(_vm._s(person.email))])], 1) : _vm._e(), _vm._v(" "), (person.title) ? _c('div', {
      staticClass: "education"
    }, [_c('span', [_vm._v("Arbejder som:")]), _vm._v(" " + _vm._s(person.title) + "\r\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.education) ? _c('div', {
      staticClass: "education"
    }, [_c('span', [_vm._v("Uddannelse:")]), _vm._v(" " + _vm._s(person.education) + "\r\n\t\t\t\t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.item.facts) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.item.facts) ? _c('div', {
    staticClass: "facts"
  }, [_c('h2', [_vm._v("Fakta om dette tilbud")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [(_vm.item.facts.form || _vm.item.facts.duration) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.facts.form) ? [_c('div', [_vm._v("Form på tilbud:")]), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.item.facts.form)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.facts.duration) ? [_c('div', [_vm._v("Længde på forløb:")]), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.item.facts.duration)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item.facts.participants || _vm.item.facts.interval) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.facts.participants) ? [_c('div', [_vm._v("Antal deltagere:")]), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.item.facts.participants)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.facts.interval) ? [_c('div', [_vm._v("Hvor ofte er der møde:")]), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.item.facts.interval)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item.organization.name || _vm.item.facts.cooperation) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.organization.name) ? [_c('div', [_vm._v("Organisation bag tilbuddet:")]), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.item.organization.name)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.facts.cooperation) ? [_c('div', [_vm._v("Laves i samarbejde med:")]), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.item.facts.cooperation)
    }
  })] : _vm._e()], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.item.location.center) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.item.location.center) ? _c('div', [_c('h2', [_vm._v("Kort")]), _vm._v(" "), _c('gmap-map', {
    staticClass: "single",
    attrs: {
      "center": {
        lat: _vm.item.location.center.lat,
        lng: _vm.item.location.center.lng
      },
      "zoom": 16,
      "options": _vm.mapOptions.settings,
      "map-type-id": "roadmap"
    }
  }, [(_vm.item.location.center) ? _c('gmap-marker', {
    attrs: {
      "icon": "../../6682bo/static/maps-marker.png",
      "position": _vm.item.location.center
    }
  }) : _vm._e()], 1)], 1) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue-loader/lib/template-compiler.js?{"id":"data-v-7cd8a2c4"}!./scripts/bo-list/bo-list-item.html
// module id = 261
// module chunks = 1